// Shared styling for the dashboard d3 charts. d3 writes SVG presentation
// attributes rather than classes, so the theme points at the same CSS variables
// the Tailwind tokens resolve to instead of restating them as literals.
export const CHART_COLORS = {
    bar: 'var(--color-accent)',
    label: 'var(--color-subtle)',
    axis: 'var(--color-subtle)',
    grid: 'var(--color-border-light)'
};

export const CHART_FONT_SIZES = {
    label: 'var(--text-sm)',
    axis: 'var(--text-xs)'
};
